import { Link } from "react-router-dom";
import { MapPin, Phone, MessageCircle } from "lucide-react";
import { STUDIO } from "../pages/Contact";

const COLS = [
  ["Collect", [["/shop?type=physical_art", "Original artworks", "physical"], ["/shop?type=digital_art", "Digital prints", "digital"], ["/shop?type=audio", "Audio", "audio"], ["/videos", "Video", "video"]]],
  ["Explore", [["/", "Home", "home"], ["/shop", "Shop", "shop"], ["/gallery", "Gallery", "gallery"], ["/about", "About Ahmad", "about"], ["/contact", "Contact", "contact"]]],
  ["Account", [["/library", "My Library", "library"], ["/orders", "Order history", "orders"], ["/cart", "Cart", "cart"]]],
];

export const Footer = () => (
  <footer className="mt-32 border-t wb-line" data-testid="site-footer">
    <div className="wb-container grid gap-12 py-16 md:grid-cols-12">
      <div className="md:col-span-4">
        <div className="font-display text-3xl tracking-tight">Warna <span className="italic text-wb-gold">Borneo</span></div>
        <p className="mt-4 max-w-sm text-sm leading-relaxed muted">
          Charcoal surrealism, digital prints and moving images by Ahmad Leong — made in Sabah, Malaysia, collected worldwide.
        </p>
        <div className="mt-6 space-y-3 text-sm muted">
          <p className="flex gap-3" data-testid="footer-address"><MapPin size={15} className="gold mt-0.5 shrink-0" /><span>{STUDIO.lines.join(", ")}</span></p>
          <a href={STUDIO.tel} className="flex gap-3 hover:text-wb-gold transition-colors" data-testid="footer-phone-link"><Phone size={15} className="gold shrink-0" />{STUDIO.phone}</a>
          <a href={STUDIO.wa} target="_blank" rel="noreferrer" className="flex gap-3 hover:text-wb-gold transition-colors" data-testid="footer-whatsapp-link"><MessageCircle size={15} className="gold shrink-0" />WhatsApp</a>
        </div>
      </div>
      {COLS.map(([title, links]) => (
        <div key={title} className="md:col-span-2 md:col-start-auto">
          <div className="eyebrow mb-5">{title}</div>
          <ul className="space-y-3 text-sm muted">
            {links.map(([to, label, id]) => (
              <li key={to}><Link to={to} className="hover:text-wb-gold transition-colors" data-testid={`footer-${id}-link`}>{label}</Link></li>
            ))}
          </ul>
        </div>
      ))}
    </div>
    <div className="wb-container flex flex-col gap-2 border-t wb-line py-6 text-xs muted font-mono sm:flex-row sm:justify-between">
      <span>© {new Date().getFullYear()} Warna Borneo · Ahmad Leong</span>
      <span>Penampang, Sabah · Prices in USD</span>
    </div>
  </footer>
);
